export default "__VITE_ASSET__BGpxBRzo__"